// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import { Container, Box, Grid, Card, CardActionArea, CardMedia, CardContent, Typography } from '@mui/material'; // Material-UIのレイアウトやUIコンポーネント
import PersonIcon from '@mui/icons-material/Person'; // ユーザーアイコン
import LockOpenIcon from '@mui/icons-material/LockOpen'; // ロック解除アイコン

/** 
 * ユーザーMyアカウントテンプレート
 * アカウント情報およびパスワード関連操作を提供するUI
 */
const UserMyAccountTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* タイトルは空の状態 */}
            {/* ページ全体を囲むコンテナ */}
            <Container maxWidth='lg'> {/* 最大幅を`lg`に設定 */}
                {/* メインのボックスで高さを設定 */}
                <Box sx={{ height: '600px' }}>
                    {/* グリッドレイアウト: アカウント情報とパスワード関連を横並びで表示 */}
                    <Grid 
                        container 
                        alignItems="center" // コンテンツを垂直方向に中央揃え
                        direction="row" // 横方向に配置
                        paddingX={6} // 横方向のパディング
                        paddingY={3} // 縦方向のパディング
                    >
                        {/* アカウント情報カード */}
                        <Grid xs={6}> {/* 横幅を全体の半分に設定 */}
                            <Card sx={{ display: 'flex', margin: 2 }}> {/* カード全体を囲む */}
                                <CardActionArea href="/userInfo"> {/* アカウント情報ページへのリンク */}
                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}> {/* カード内のレイアウトを横方向に配置 */}
                                        {/* アイコン表示 */}
                                        <CardMedia>
                                            <PersonIcon sx={{ fontSize: '120px' }} />
                                        </CardMedia>
                                        {/* テキスト内容 */}
                                        <CardContent sx={{ width: '280px' }}>
                                            <Typography gutterBottom variant="h6" component="div">
                                                アカウント情報
                                            </Typography>
                                        </CardContent>
                                    </Box>
                                </CardActionArea>
                            </Card>
                        </Grid>

                        {/* パスワード確認・変更カード */}
                        <Grid xs={6}> {/* 横幅を全体の半分に設定 */}
                            <Card sx={{ display: 'flex', margin: 2 }}> {/* カード全体を囲む */}
                                <CardActionArea href="/userPass"> {/* パスワード確認・変更ページへのリンク */}
                                    <Box sx={{ display: 'flex', flexDirection: 'row' }}> {/* カード内のレイアウトを横方向に配置 */}
                                        {/* アイコン表示 */}
                                        <CardMedia>
                                            <LockOpenIcon sx={{ fontSize: '120px' }} />
                                        </CardMedia>
                                        {/* テキスト内容 */}
                                        <CardContent sx={{ width: '280px' }}>
                                            <Typography gutterBottom variant="h6" component="div">
                                                パスワード確認・変更
                                            </Typography>
                                        </CardContent>
                                    </Box>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </UserFrame>
    )
}

// コンポーネントをエクスポート
export default UserMyAccountTemplate;
